// Module
var code = "<p>If you choose to <a href=\"/manage/consolidation\">consolidate</a> your federal student loans, you may be eligible for <a href=\"https://studentaid.gov/manage-loans/forgiveness-cancellation/public-service\">PSLF.</a></p> <p><strong>NOTE:</strong> You may lose your eligibility for SCRA if you consolidate your student loans.</p> ";
// Exports
export default code;